<div class="cart-container" style="margin-bottom: 70px;" *ngIf="cartItems.length > 0; else emptyCart">

  <!-- ================= CART ITEMS ================= -->
  <div class="cart-item" *ngFor="let item of cartItems">

    <!-- =================== BUNDLE ITEM =================== -->
    <!-- =================== BUNDLE ITEM (SAME PRODUCT STYLE) =================== -->
    <div *ngIf="item.type === 'bundle'" class="normal-cart">

      <!-- Bundle Image -->
      <img class="product-image pointer" (click)="productDetails(item.product)"
        [lazyLoad]="fixImage(item.product.image)" alt="bundle" />

      <!-- Details -->
      <div class="product-details">

        <!-- Name -->
        <p class="product-name">
          {{ isAr ? item.product.name_ar : item.product.name_en }}
          <span class="bundle-tag"> {{ "deal" | transloco}}</span>
        </p>
        <p class="product-name">
          {{ isAr ? item.product.description_ar : item.product.description_en }}

        </p>

        <!-- Bundle Items داخل نفس الكارت -->
        <ul class="bundle-inline">
          <li *ngFor="let sub of item.items">
            ×{{ sub.quantity * item.quantity }}
            {{ isAr ? sub.stock.name_ar : sub.stock.name_en }}
          </li>
        </ul>

        <!-- Price -->
        <div class="price">
          <span class="new-price">
            {{ item.product.pricea }} {{ "egpe" | transloco }}
          </span>

          <span class="old-price" *ngIf="calcDis(item.product.pricea,item.product.pricec) != 0">
            {{ item.product.pricec }} {{ "egpe" | transloco }}
          </span>
        </div>

        <!-- Quantity -->
        <div class="quantity-controls">
          <button (click)="decreaseQuantity(item)">−</button>
          <span>{{ item.quantity }}</span>
          <button (click)="increaseQuantity(item)">+</button>
        </div>

      </div>
    </div>


    <!-- =================== NORMAL PRODUCT =================== -->
    <div *ngIf="item.type !== 'bundle'" class="normal-cart">

      <!-- Image -->
      <img class="product-image pointer" (click)="productDetails(item.product)"
        [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(item.product.image)"
        [errorImage]="'/assets/noproduct.png'" alt="product" />

      <!-- Details -->
      <div class="product-details">

        <p class="product-name">
          {{ isAr ? item.product.name_ar : item.product.name_en }} <span *ngIf="item.product.is_free_reward">
            <img class="chip-img" src="/assets/e-commerce/icons/77.webp" alt=" item" />
          </span>

        </p>

        <!-- Price -->
        <div class="price">
          <span class="new-price">
            @if(item.product.is_daily_offer){

            {{ item.product.affiliationprice }} {{ "egpe" | transloco }}
            }
            @else{
            {{ item.product.pricea }} {{ "egpe" | transloco }}
            }
          </span>

          <span class="old-price" *ngIf="calcDis(item.product.pricea,item.product.pricec) != 0">
            {{ item.product.pricec }} {{ "egpe" | transloco }}
          </span>
        </div>

        <!-- Quantity Controls -->
        <div class="quantity-controls">
          <button (click)="decreaseQuantity(item)">−</button>
          <span>{{ item.quantity }}</span>
          <button (click)="increaseQuantity(item)">+</button>
        </div>

      </div>
    </div>

  </div>


  <!-- ================= CART SUMMARY ================= -->
  <div class="cart-summary">

    <div class="total">
      <span>{{ "total" | transloco }} :</span>

      <strong>
        {{ getTotal() }} {{ "egpe" | transloco }}

        <span class="old-price">
          {{ getDiscountTotal() }} {{ "egpe" | transloco }}
        </span>
      </strong>
    </div>

    <button class="checkout-btn clear-cart" (click)="clearCart()">
      {{ "clearcart" | transloco }}
    </button>

    <button class="checkout-btn" [class.disabled-btn]="isOnlyWheelRewardCart()" (click)="handleCheckout()">

      {{ "checkout" | transloco }}
    </button>



  </div>
</div>


<!-- ================= EMPTY CART ================= -->
<ng-template #emptyCart>
  <app-emptycart></app-emptycart>
</ng-template>